export type CountryCode = {
  name: string
  code: string
  dialCode: string
  flag: string
  timeZone: string
  placeholder?: string
  mask?: string
  regex?: string
  format?: string
}

export const COUNTRY_CODES: CountryCode[] = [
  {
    name: 'United States',
    code: 'US',
    dialCode: '+1',
    flag: '🇺🇸',
    timeZone: 'America/New_York',
    placeholder: '(555) 123-4567',
    mask: '(000) 000-0000',
    regex: '^\\+1(\\d{3})(\\d{3})(\\d{4})$',
    format: '+1 ($1) $2-$3',
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    dialCode: '+44',
    flag: '🇬🇧',
    timeZone: 'Europe/London',
    placeholder: '7400 123456',
    mask: '0000 000000',
    regex: '^\\+44(\\d{4})(\\d{6})$',
    format: '+44 $1 $2',
  },
  {
    name: 'Australia',
    code: 'AU',
    dialCode: '+61',
    flag: '🇦🇺',
    timeZone: 'Australia/Sydney',
    placeholder: '412 345 678',
    mask: '000 000 000',
    regex: '^\\+61(\\d{3})(\\d{3})(\\d{3})$',
    format: '+61 $1 $2 $3',
  },
  {
    name: 'Germany',
    code: 'DE',
    dialCode: '+49',
    flag: '🇩🇪',
    timeZone: 'Europe/Berlin',
    placeholder: '1512 3456789',
    mask: '0000 0000000',
    regex: '^\\+49(\\d{4})(\\d{7})$',
    format: '+49 $1 $2',
  },
  {
    name: 'France',
    code: 'FR',
    dialCode: '+33',
    flag: '🇫🇷',
    timeZone: 'Europe/Paris',
    placeholder: '6 12 34 56 78',
    mask: '0 00 00 00 00',
    regex: '^\\+33(\\d{1})(\\d{2})(\\d{2})(\\d{2})(\\d{2})$',
    format: '+33 $1 $2 $3 $4 $5',
  },
  {
    name: 'Italy',
    code: 'IT',
    dialCode: '+39',
    flag: '🇮🇹',
    timeZone: 'Europe/Rome',
    placeholder: '312 345 6789',
    mask: '000 000 0000',
    regex: '^\\+39(\\d{3})(\\d{3})(\\d{4})$',
    format: '+39 $1 $2 $3',
  },
  {
    name: 'Spain',
    code: 'ES',
    dialCode: '+34',
    flag: '🇪🇸',
    timeZone: 'Europe/Madrid',
    placeholder: '612 34 56 78',
    mask: '000 00 00 00',
    regex: '^\\+34(\\d{3})(\\d{2})(\\d{2})(\\d{2})$',
    format: '+34 $1 $2 $3 $4',
  },
  {
    name: 'Mexico',
    code: 'MX',
    dialCode: '+52',
    flag: '🇲🇽',
    timeZone: 'America/Mexico_City',
    placeholder: '55 1234 5678',
    mask: '00 0000 0000',
    regex: '^\\+52(\\d{2})(\\d{4})(\\d{4})$',
    format: '+52 $1 $2 $3',
  },
  {
    name: 'Brazil',
    code: 'BR',
    dialCode: '+55',
    flag: '🇧🇷',
    timeZone: 'America/Sao_Paulo',
    placeholder: '11 91234-5678',
    mask: '00 00000-0000',
    regex: '^\\+55(\\d{2})(\\d{5})(\\d{4})$',
    format: '+55 $1 $2-$3',
  },
  {
    name: 'Argentina',
    code: 'AR',
    dialCode: '+54',
    flag: '🇦🇷',
    timeZone: 'America/Argentina/Buenos_Aires',
    placeholder: '11 2345-6789',
    mask: '00 0000-0000',
    regex: '^\\+54(\\d{2})(\\d{4})(\\d{4})$',
    format: '+54 $1 $2-$3',
  },
  {
    name: 'China',
    code: 'CN',
    dialCode: '+86',
    flag: '🇨🇳',
    timeZone: 'Asia/Shanghai',
    placeholder: '131 2345 6789',
    mask: '000 0000 0000',
    regex: '^\\+86(\\d{3})(\\d{4})(\\d{4})$',
    format: '+86 $1 $2 $3',
  },
  {
    name: 'Japan',
    code: 'JP',
    dialCode: '+81',
    flag: '🇯🇵',
    timeZone: 'Asia/Tokyo',
    placeholder: '90-1234-5678',
    mask: '00-0000-0000',
    regex: '^\\+81(\\d{2})(\\d{4})(\\d{4})$',
    format: '+81 $1-$2-$3',
  },
  {
    name: 'South Korea',
    code: 'KR',
    dialCode: '+82',
    flag: '🇰🇷',
    timeZone: 'Asia/Seoul',
    placeholder: '10-1234-5678',
    mask: '00-0000-0000',
    regex: '^\\+82(\\d{2})(\\d{4})(\\d{4})$',
    format: '+82 $1-$2-$3',
  },
  {
    name: 'India',
    code: 'IN',
    dialCode: '+91',
    flag: '🇮🇳',
    timeZone: 'Asia/Kolkata',
    placeholder: '81234 56789',
    mask: '00000 00000',
    regex: '^\\+91(\\d{5})(\\d{5})$',
    format: '+91 $1 $2',
  },
  {
    name: 'South Africa',
    code: 'ZA',
    dialCode: '+27',
    flag: '🇿🇦',
    timeZone: 'Africa/Johannesburg',
    placeholder: '71 123 4567',
    mask: '00 000 0000',
    regex: '^\\+27(\\d{2})(\\d{3})(\\d{4})$',
    format: '+27 $1 $2 $3',
  },
  {
    name: 'Turkey',
    code: 'TR',
    dialCode: '+90',
    flag: '🇹🇷',
    timeZone: 'Europe/Istanbul',
    placeholder: '501 234 5678',
    mask: '000 000 0000',
    regex: '^\\+90(\\d{3})(\\d{3})(\\d{4})$',
    format: '+90 $1 $2 $3',
  },
  {
    name: 'Netherlands',
    code: 'NL',
    dialCode: '+31',
    flag: '🇳🇱',
    timeZone: 'Europe/Amsterdam',
    placeholder: '6 12345678',
    mask: '0 00000000',
    regex: '^\\+31(\\d{1})(\\d{8})$',
    format: '+31 $1 $2',
  },
  {
    name: 'Belgium',
    code: 'BE',
    dialCode: '+32',
    flag: '🇧🇪',
    timeZone: 'Europe/Brussels',
    placeholder: '470 12 34 56',
    mask: '000 00 00 00',
    regex: '^\\+32(\\d{3})(\\d{2})(\\d{2})(\\d{2})$',
    format: '+32 $1 $2 $3 $4',
  },
  {
    name: 'Switzerland',
    code: 'CH',
    dialCode: '+41',
    flag: '🇨🇭',
    timeZone: 'Europe/Zurich',
    placeholder: '78 123 45 67',
    mask: '00 000 00 00',
    regex: '^\\+41(\\d{2})(\\d{3})(\\d{2})(\\d{2})$',
    format: '+41 $1 $2 $3 $4',
  },
  {
    name: 'Austria',
    code: 'AT',
    dialCode: '+43',
    flag: '🇦🇹',
    timeZone: 'Europe/Vienna',
    placeholder: '664 123456',
    mask: '000 000000',
    regex: '^\\+43(\\d{3})(\\d{6})$',
    format: '+43 $1 $2',
  },
  {
    name: 'Sweden',
    code: 'SE',
    dialCode: '+46',
    flag: '🇸🇪',
    timeZone: 'Europe/Stockholm',
    placeholder: '70 123 45 67',
    mask: '00 000 00 00',
    regex: '^\\+46(\\d{2})(\\d{3})(\\d{2})(\\d{2})$',
    format: '+46 $1 $2 $3 $4',
  },
  {
    name: 'Norway',
    code: 'NO',
    dialCode: '+47',
    flag: '🇳🇴',
    timeZone: 'Europe/Oslo',
    placeholder: '406 12 345',
    mask: '000 00 000',
    regex: '^\\+47(\\d{3})(\\d{2})(\\d{3})$',
    format: '+47 $1 $2 $3',
  },
  {
    name: 'Denmark',
    code: 'DK',
    dialCode: '+45',
    flag: '🇩🇰',
    timeZone: 'Europe/Copenhagen',
    placeholder: '32 12 34 56',
    mask: '00 00 00 00',
    regex: '^\\+45(\\d{2})(\\d{2})(\\d{2})(\\d{2})$',
    format: '+45 $1 $2 $3 $4',
  },
  {
    name: 'Finland',
    code: 'FI',
    dialCode: '+358',
    flag: '🇫🇮',
    timeZone: 'Europe/Helsinki',
    placeholder: '41 2345678',
    mask: '00 0000000',
    regex: '^\\+358(\\d{2})(\\d{7})$',
    format: '+358 $1 $2',
  },
  {
    name: 'Poland',
    code: 'PL',
    dialCode: '+48',
    flag: '🇵🇱',
    timeZone: 'Europe/Warsaw',
    placeholder: '512 345 678',
    mask: '000 000 000',
    regex: '^\\+48(\\d{3})(\\d{3})(\\d{3})$',
    format: '+48 $1 $2 $3',
  },
  {
    name: 'Portugal',
    code: 'PT',
    dialCode: '+351',
    flag: '🇵🇹',
    timeZone: 'Europe/Lisbon',
    placeholder: '912 345 678',
    mask: '000 000 000',
    regex: '^\\+351(\\d{3})(\\d{3})(\\d{3})$',
    format: '+351 $1 $2 $3',
  },
  {
    name: 'Greece',
    code: 'GR',
    dialCode: '+30',
    flag: '🇬🇷',
    timeZone: 'Europe/Athens',
    placeholder: '691 234 5678',
    mask: '000 000 0000',
    regex: '^\\+30(\\d{3})(\\d{3})(\\d{4})$',
    format: '+30 $1 $2 $3',
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
    dialCode: '+420',
    flag: '🇨🇿',
    timeZone: 'Europe/Prague',
    placeholder: '601 123 456',
    mask: '000 000 000',
    regex: '^\\+420(\\d{3})(\\d{3})(\\d{3})$',
    format: '+420 $1 $2 $3',
  },
  {
    name: 'Ireland',
    code: 'IE',
    dialCode: '+353',
    flag: '🇮🇪',
    timeZone: 'Europe/Dublin',
    placeholder: '85 123 4567',
    mask: '00 000 0000',
    regex: '^\\+353(\\d{2})(\\d{3})(\\d{4})$',
    format: '+353 $1 $2 $3',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    dialCode: '+64',
    flag: '🇳🇿',
    timeZone: 'Pacific/Auckland',
    placeholder: '21 123 4567',
    mask: '00 000 0000',
    regex: '^\\+64(\\d{2})(\\d{3})(\\d{4})$',
    format: '+64 $1 $2 $3',
  },
  {
    name: 'Singapore',
    code: 'SG',
    dialCode: '+65',
    flag: '🇸🇬',
    timeZone: 'Asia/Singapore',
    placeholder: '8123 4567',
    mask: '0000 0000',
    regex: '^\\+65(\\d{4})(\\d{4})$',
    format: '+65 $1 $2',
  },
  {
    name: 'Malaysia',
    code: 'MY',
    dialCode: '+60',
    flag: '🇲🇾',
    timeZone: 'Asia/Kuala_Lumpur',
    placeholder: '12-345 6789',
    mask: '00-000 0000',
    regex: '^\\+60(\\d{2})(\\d{3})(\\d{4})$',
    format: '+60 $1-$2 $3',
  },
  {
    name: 'Thailand',
    code: 'TH',
    dialCode: '+66',
    flag: '🇹🇭',
    timeZone: 'Asia/Bangkok',
    placeholder: '81 234 5678',
    mask: '00 000 0000',
    regex: '^\\+66(\\d{2})(\\d{3})(\\d{4})$',
    format: '+66 $1 $2 $3',
  },
  {
    name: 'Indonesia',
    code: 'ID',
    dialCode: '+62',
    flag: '🇮🇩',
    timeZone: 'Asia/Jakarta',
    placeholder: '812-3456-7890',
    mask: '000-0000-0000',
    regex: '^\\+62(\\d{3})(\\d{4})(\\d{4})$',
    format: '+62 $1-$2-$3',
  },
  {
    name: 'Philippines',
    code: 'PH',
    dialCode: '+63',
    flag: '🇵🇭',
    timeZone: 'Asia/Manila',
    placeholder: '905 123 4567',
    mask: '000 000 0000',
    regex: '^\\+63(\\d{3})(\\d{3})(\\d{4})$',
    format: '+63 $1 $2 $3',
  },
  {
    name: 'Vietnam',
    code: 'VN',
    dialCode: '+84',
    flag: '🇻🇳',
    timeZone: 'Asia/Ho_Chi_Minh',
    placeholder: '91 234 5678',
    mask: '00 000 0000',
    regex: '^\\+84(\\d{2})(\\d{3})(\\d{4})$',
    format: '+84 $1 $2 $3',
  },
  {
    name: 'Israel',
    code: 'IL',
    dialCode: '+972',
    flag: '🇮🇱',
    timeZone: 'Asia/Jerusalem',
    placeholder: '50-123-4567',
    mask: '00-000-0000',
    regex: '^\\+972(\\d{2})(\\d{3})(\\d{4})$',
    format: '+972 $1-$2-$3',
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    dialCode: '+971',
    flag: '🇦🇪',
    timeZone: 'Asia/Dubai',
    placeholder: '50 123 4567',
    mask: '00 000 0000',
    regex: '^\\+971(\\d{2})(\\d{3})(\\d{4})$',
    format: '+971 $1 $2 $3',
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
    dialCode: '+966',
    flag: '🇸🇦',
    timeZone: 'Asia/Riyadh',
    placeholder: '50 123 4567',
    mask: '00 000 0000',
    regex: '^\\+966(\\d{2})(\\d{3})(\\d{4})$',
    format: '+966 $1 $2 $3',
  },
  {
    name: 'Egypt',
    code: 'EG',
    dialCode: '+20',
    flag: '🇪🇬',
    timeZone: 'Africa/Cairo',
    placeholder: '100 123 4567',
    mask: '000 000 0000',
    regex: '^\\+20(\\d{3})(\\d{3})(\\d{4})$',
    format: '+20 $1 $2 $3',
  },
  {
    name: 'Nigeria',
    code: 'NG',
    dialCode: '+234',
    flag: '🇳🇬',
    timeZone: 'Africa/Lagos',
    placeholder: '802 123 4567',
    mask: '000 000 0000',
    regex: '^\\+234(\\d{3})(\\d{3})(\\d{4})$',
    format: '+234 $1 $2 $3',
  },
  {
    name: 'Kenya',
    code: 'KE',
    dialCode: '+254',
    flag: '🇰🇪',
    timeZone: 'Africa/Nairobi',
    placeholder: '712 345678',
    mask: '000 000000',
    regex: '^\\+254(\\d{3})(\\d{6})$',
    format: '+254 $1 $2',
  },
  {
    name: 'Chile',
    code: 'CL',
    dialCode: '+56',
    flag: '🇨🇱',
    timeZone: 'America/Santiago',
    placeholder: '9 1234 5678',
    mask: '0 0000 0000',
    regex: '^\\+56(\\d{1})(\\d{4})(\\d{4})$',
    format: '+56 $1 $2 $3',
  },
  {
    name: 'Colombia',
    code: 'CO',
    dialCode: '+57',
    flag: '🇨🇴',
    timeZone: 'America/Bogota',
    placeholder: '321 1234567',
    mask: '000 0000000',
    regex: '^\\+57(\\d{3})(\\d{7})$',
    format: '+57 $1 $2',
  },
  {
    name: 'Peru',
    code: 'PE',
    dialCode: '+51',
    flag: '🇵🇪',
    timeZone: 'America/Lima',
    placeholder: '912 345 678',
    mask: '000 000 000',
    regex: '^\\+51(\\d{3})(\\d{3})(\\d{3})$',
    format: '+51 $1 $2 $3',
  },
  {
    name: 'Venezuela',
    code: 'VE',
    dialCode: '+58',
    flag: '🇻🇪',
    timeZone: 'America/Caracas',
    placeholder: '412-1234567',
    mask: '000-0000000',
    regex: '^\\+58(\\d{3})(\\d{7})$',
    format: '+58 $1-$2',
  },
  {
    name: 'Ukraine',
    code: 'UA',
    dialCode: '+380',
    flag: '🇺🇦',
    timeZone: 'Europe/Kiev',
    placeholder: '50 123 4567',
    mask: '00 000 0000',
    regex: '^\\+380(\\d{2})(\\d{3})(\\d{4})$',
    format: '+380 $1 $2 $3',
  },
  {
    name: 'Romania',
    code: 'RO',
    dialCode: '+40',
    flag: '🇷🇴',
    timeZone: 'Europe/Bucharest',
    placeholder: '712 345 678',
    mask: '000 000 000',
    regex: '^\\+40(\\d{3})(\\d{3})(\\d{3})$',
    format: '+40 $1 $2 $3',
  },
]
